// Отладочный журнал сценария «Это взаимно».
// Пишется в консоль (префикс [MATCH]) и в localStorage — переживает
// перезагрузку, поэтому лог можно снять уже ПОСЛЕ неудачного показа.
//
// Как снять дамп: в консоли браузера набрать  __matchDump()
// (текст также копируется в буфер обмена). Очистить: __matchDumpClear()
const STORAGE_KEY = 'match_debug_log';
const MAX_ENTRIES = 150;

function readLog() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
  } catch {
    return [];
  }
}

function writeLog(entries) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(entries.slice(-MAX_ENTRIES)));
  } catch {
    /* переполнение хранилища не должно ломать приложение */
  }
}

export function logMatchEvent(type, payload = {}) {
  const entry = {
    t: new Date().toISOString().slice(11, 23),
    type,
    ...payload
  };

  const entries = readLog();
  entries.push(entry);
  writeLog(entries);

  console.log(`[MATCH] ${type}`, payload);
  return entry;
}

export function getMatchDebugDump() {
  return readLog()
    .map((e) => `${e.t} ${e.type} ${JSON.stringify(e, (k, v) => (k === 't' || k === 'type' ? undefined : v))}`)
    .join('\n');
}

if (typeof window !== 'undefined') {
  // __matchDump() — вывести дамп в консоль и скопировать в буфер обмена
  window.__matchDump = () => {
    const text = getMatchDebugDump() || '(лог пуст)';
    console.log(text);
    try {
      navigator.clipboard?.writeText(text);
      console.log('[MATCH] дамп скопирован в буфер обмена');
    } catch {
      /* clipboard недоступен — текст виден в консоли */
    }
    return text;
  };

  window.__matchDumpClear = () => {
    writeLog([]);
    console.log('[MATCH] журнал очищен');
  };
}
